module.exports = __webpack_public_path__ + "static/img/pause-big.2f8d191.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/pause-big.png
// module id = +G7c
// module chunks = 30